import "simplebar";

var ProgressBar = require("progressbar.js");

(function ($) {
  $(document).ready(function () {
    const $passport = $("section#user-passport");

    if ($passport.length === 0) {
      return;
    }

    /**
     * Login form placeholders.
     */
    $passport.find("#user_login").attr("placeholder", "Username or e-mail");
    $passport.find("#user_pass").attr("placeholder", "Password");

    /**
     * Progress bars.
     */
    [1, 2, 3, 4, 5, 6, 7].forEach(function (index) {
      const selector = `div.progress-bar.pb-${index}`;
      const $el = $(selector);
      const color = $el.data("color");
      const percent = parseInt($el.data("percent")) / 100;

      const bar = new ProgressBar.SemiCircle(selector, {
        strokeWidth: 8,
        color: color,
        trailColor: "#777",
        trailWidth: 1,
        easing: "easeInOut",
        duration: 1400,
      });

      bar.path.style.strokeLinecap = "round";
      bar.animate(percent);
    });

    /**
     * Tabs logic.
     */
    const $tabs = $passport.find("ul.tabs li");
    const $contents = $passport.find("div.tab-content");

    $tabs.click(function () {
      const $tab = $(this);
      const $content = $contents.eq($tab.index());

      if ($tab.hasClass("active")) {
        return;
      }

      $tabs.filter(".active").removeClass("active");
      $contents.filter(".active").removeClass("active");
      $tab.addClass("active");
      $content.addClass("active");
    });

    /**
     * Subtabs logic.
     */
    const $subtabs = $passport.find("ul.subtabs li");
    const $subcontents = $passport.find("div.subtab-content");

    $subtabs.click(function () {
      const $tab = $(this);
      const $content = $subcontents.eq($tab.index());

      if ($tab.hasClass("active")) {
        return;
      }

      $subtabs.filter(".active").removeClass("active");
      $subcontents.filter(".active").removeClass("active");
      $tab.addClass("active");
      $content.addClass("active");
    });

    /**
     * Direct shortcut to a country subtab.
     */
    $("[data-country-tab]").click(function () {
      const index = parseInt($(this).data("country-tab"));

      $tabs.eq(0).click();
      $subtabs.eq(index).click();
    });

    /**
     * Avatar upload AJAX.
     */
    const $avatar_container = $("#avatar-container");
    const $uploader = $passport.find("div.uploader");
    const $input = $("#avatar").eq(0);

    $uploader.click(function () {
      $input.trigger("click");
    });

    $input.change(function () {
      const formData = new FormData();
      const files = $("#avatar")[0].files;

      if (files.length > 0) {
        formData.append("file", files[0]);
        formData.append("_wpnonce", Progress360.api.nonce);

        $avatar_container.addClass("loading");

        $.ajax({
          url: `${Progress360.api.rest_url}progress360/v1/public/upload-avatar`,
          type: "POST",
          data: formData,
          contentType: false,
          processData: false,
          success: function (response) {
            $avatar_container.removeClass("loading");

            if (response.success) {
              $("#avatar-image").attr("src", response.new_avatar);
            } else {
              alert(response.message || "An error occurred, please try again.");
            }
          },
        });
      }
    });

    /**
     * Avatar selector list widget.
     */
    const $avatars_list = $("#avatars-list");
    const $selector_opener = $("#avatar-container div.avatar-selector").eq(0);

    $selector_opener.click(function () {
      $avatars_list.slideToggle();
    });

    $avatars_list.find("ul li").click(function () {
      const index = parseInt($(this).data("avatar"));

      $avatar_container.addClass("loading");

      $.ajax({
        url: `${Progress360.api.rest_url}progress360/v1/public/select-predefined-avatar`,
        type: "POST",
        data: {
          index: index,
          _wpnonce: Progress360.api.nonce,
        },
        success: function (response) {
          $avatar_container.removeClass("loading");
          $avatars_list.slideUp();

          if (response.success) {
            $("#avatar-image").attr("src", response.new_avatar);
          } else {
            alert(response.message || "An error occurred, please try again.");
          }
        },
      });
    });

    /**
     * Traveler type edition.
     */
    const $type_container = $("div#traveler-type-container");
    const $type_toggler = $type_container.find("span.instructions").eq(0);
    const $type_select = $type_container.find("select#traveler-type").eq(0);

    $type_toggler.click(function () {
      $type_container.addClass("open");
    });

    $type_select.change(function () {
      $.ajax({
        url: `${Progress360.api.rest_url}progress360/v1/public/passport-update`,
        type: "POST",
        data: {
          traveler_type: $type_select.val(),
          _wpnonce: Progress360.api.nonce,
        },
        success: function (response) {
          $type_container.removeClass("open");
          $type_container.find("h6").text(response.new_type);
        },
      });
    });
  });
})(jQuery);
